import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "运费配置", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("按金额（商品总价达到门槛免运）")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("按件数（商品件数达到门槛免运）")
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "元", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-gray-400" }, "开启后，未达免运门槛时用户可选择到付", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      rules: _ctx.rules,
      "label-width": "140px"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          label: "免运模式",
          prop: "mode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.mode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mode) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "amount" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "count" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "免运门槛",
          prop: "threshold"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.formData.threshold,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.threshold) = $event)),
              min: 0,
              precision: 0,
              step: 1
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formData.mode === 'count' ? '件' : '元'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "运费金额",
          prop: "delivery_fee"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.formData.delivery_fee,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.delivery_fee) = $event)),
              min: 0,
              precision: 0,
              step: 1
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "支持到付" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.formData.freight_collect,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.freight_collect) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}